<mat-card class="add-paypoint-card">
  <mat-card-header>
    <mat-card-title>Add New Paypoint</mat-card-title>
    <button mat-raised-button (click)="this.addPaypoint.emit()">
      <mat-icon>arrow_back</mat-icon>
      Back to Paypoints
    </button>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="addPaypointForm" (ngSubmit)="onSave()">
      <!-- Auto-generated Paypoint Code (disabled) -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Paypoint Code</mat-label>
        <input matInput formControlName="paypointCode" placeholder="Auto-generated" disabled />
        <mat-hint>Auto-generated by system</mat-hint>
      </mat-form-field>

      <!-- Provider Selection -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Provider</mat-label>
        <mat-select formControlName="provider">
          <mat-option *ngFor="let option of providerOptions" [value]="option.value">
            {{ option.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Dynamic Provider Configuration -->
      <ng-container *ngIf="addPaypointForm.get('provider').value === 'orientalbank'">
        <mat-card class="config-card">
          <mat-card-subtitle>Oriental Bank Configuration</mat-card-subtitle>
          <div class="config-fields">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Store ID</mat-label>
              <input matInput formControlName="storeId" placeholder="Enter Store ID" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Store Key</mat-label>
              <input
                matInput
                type="password"
                formControlName="storeKey"
                placeholder="Enter Store Key"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Entity ID</mat-label>
              <input matInput formControlName="entityId" placeholder="Enter Entity ID" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Location ID</mat-label>
              <input matInput formControlName="locationId" placeholder="Enter Location ID" />
            </mat-form-field>
          </div>
        </mat-card>
      </ng-container>

      <ng-container *ngIf="addPaypointForm.get('provider').value === 'stripe'">
        <mat-card class="config-card">
          <mat-card-subtitle>Stripe Configuration</mat-card-subtitle>
          <div class="config-fields">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>API Key</mat-label>
              <input
                matInput
                type="password"
                formControlName="apiKey"
                placeholder="Enter API Key"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Publishable Key</mat-label>
              <input
                matInput
                formControlName="publishableKey"
                placeholder="Enter Publishable Key"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Webhook Secret</mat-label>
              <input
                matInput
                type="password"
                formControlName="webhookSecret"
                placeholder="Enter Webhook Secret"
              />
            </mat-form-field>
          </div>
        </mat-card>
      </ng-container>

      <!-- Form Actions -->
      <div class="form-actions">
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="onVerifyCredentials()"
          [disabled]="addPaypointForm.invalid"
        >
          <mat-icon>verified_user</mat-icon>
          Verify Credentials
        </button>
        <button
          mat-raised-button
          type="submit"
          [disabled]="isSubmitting || addPaypointForm.invalid"
        >
          <mat-icon>save</mat-icon>
          Save Paypoint
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
